import { useState, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { Input } from '../../../../../../../../components/input/input';
import { Modal, ModalProps } from '../../../../../../../../components/modal/modal';
import { MultiSelect } from '../../../../../../../../features/multi-select/multi-select';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useIikoStore } from '../../../../../../../../store/use-iiko-store';
import { getMenuId } from '../../../../menu-informer/menu-informer-helpers';

export const MenuIikoTableHeaderSettingsModal = (props: ModalProps) => {
  const { t } = useLang();
  const { menu, terminalList, putMenu } = useIikoStore();
  const menuId = getMenuId();

  const debouncedPutMenu = useDebouncedCallback(putMenu, 500);

  const [kaspiLink, setKaspiLink] = useState(menu?.kaspi_link);

  const handleChangeKaspiLink = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newKaspiLink = e.currentTarget.value;
    setKaspiLink(newKaspiLink);
    debouncedPutMenu({ ...menu, kaspi_link: newKaspiLink });
  };

  useEffect(() => {
    if (!menuId) return;
    setKaspiLink(menu?.kaspi_link || '');
  }, [menu]);

  return (
    <Modal {...props} title={t('Настройки')}>
      <Input
        placeholder={t('Ссылка для удаленной оплаты Kaspi')}
        style={{ width: 300 }}
        value={kaspiLink}
        onChange={handleChangeKaspiLink}
      />
      <MultiSelect
        placeholder={t('Терминал для приема заказов')}
        options={terminalList || []}
        style={{ width: 300 }}
        value={menu?.terminal_groups}
        onSelect={(e) => putMenu({ ...menu, terminal_groups: e })}
      />
    </Modal>
  );
};
